export default __webpack_public_path__ + "static/media/invite_grey.94420597.svg";